import { render, staticRenderFns } from "./KoreanLsportCartNew.vue?vue&type=template&id=9daaa134&scoped=true"
import script from "./KoreanLsportCartNew.vue?vue&type=script&lang=js"
export * from "./KoreanLsportCartNew.vue?vue&type=script&lang=js"
import style0 from "./KoreanLsportCartNew.vue?vue&type=style&index=0&id=9daaa134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9daaa134",
  null
  
)

export default component.exports